export default __webpack_public_path__ + "static/NotoSans-LightItalic-ce1e88fe8cce66b8fdc20cebd8f84a1a.ttf";